import { Edit, NumberInput, SimpleForm, TextInput } from "@/components/admin"
import { ReactElement } from "react"

const MaterialEdit = (): ReactElement => {
  return (
    <Edit mutationMode="optimistic">
      <SimpleForm>
        <TextInput source="name" label="Nom" required />
        <TextInput
          source="description"
          label="Description"
          multiline
          rows={4}
        />
        <TextInput source="category" label="Catégorie" />
        <TextInput source="unit" label="Unité" />
        <NumberInput source="price" label="Prix" />
        <NumberInput source="stock_quantity" label="Quantité en stock" />
        <TextInput source="supplier" label="Fournisseur" />
      </SimpleForm>
    </Edit>
  )
}

export default MaterialEdit
